import { FireStoreModule } from 'fb';
import firebase from 'fb/index';
import 'firebase/firestore';
import { updateIdcard } from 'store/data/idcard/actions';

export class IDCardFireStoreModule implements FireStoreModule {
	public getModuleName = () => 'idcard';
	public getOpsKeySuffix = () => 'global';
	public getFBWatchQuery = (db: firebase.firestore.Firestore) => db.collection('idcard');
	public getChangeProcessAction = (changes) => updateIdcard(changes);
}
